import { createContext, useContext, FC, ReactNode, useState, Dispatch, SetStateAction, useMemo } from 'react';

interface DrawerContextProps {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>;
  setWidth: Dispatch<SetStateAction<number | undefined>>;
  width?: number;
}

export interface DrawerProviderProps {
  children: ReactNode;
}

const DrawerContext = createContext<DrawerContextProps | undefined>(undefined);

export function useDrawer() {
  const context = useContext(DrawerContext);
  if (!context) {
    throw new Error('useDrawer must be used within a DrawerProvider');
  }
  return context;
}

export const DrawerProvider: FC<DrawerProviderProps> = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [width, setWidth] = useState<number | undefined>(undefined);

  const value = useMemo(() => ({ open, setOpen, width, setWidth }), [open, width]);

  return (
    <DrawerContext.Provider value={value}>
      {children}
    </DrawerContext.Provider>
  );
};
